
import axiosInstance from "../instance/AxiosInstance";


export const annualReportsApi = {
  fetchAnnualReports: async (params) => {
    try {
      const { from_year, to_year, from_date, to_date } = params;
      const response = await axiosInstance.get(`/reports/annualreports`, {
        params: {
          from_year,
          to_year,
          from_date,
          to_date
        },
        headers: {
          'Content-Type': 'application/json',
          // Add authorization header if needed
          // 'Authorization': `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};